module.exports = __webpack_public_path__ + "a428ed2b2f4a1f07cfed02e5eccd0521.pdf";